import styles from "./DeliverySlots.module.scss";
import classNames from "classnames";
import { Slot } from "../../EarliestAvailableSlots";
import { dispatchMonetateQEvent } from "../../../../utils/monetate/monetateQ";
import { DeliveryCheckerEvents } from "../../events/ListenEvents";

type Props = {
  slots: Slot[];
};

const DeliverySlots = ({ slots }: Props) => {
  dispatchMonetateQEvent(
    DeliveryCheckerEvents.DELIVERY_CHECKER_RESULTS_DISPLAYED,
  );
  return (
    <div className={classNames(styles.DeliverySlot)}>
      <div className={styles.DeliverySlot__highlighted}>
        Earliest delivery dates
      </div>
      {slots.map((slot, index) => (
        <div
          key={`available-slot-${index}`}
          className={styles.DeliverySlot__deliverySlotRow}
        >
          <div
            className={styles.DeliverySlot__title}
            data-testid={`slot-${index}`}
          >
            {slot.description}
          </div>
          <div className={styles.DeliverySlot__highlighted}>{slot.cost}</div>
        </div>
      ))}
    </div>
  );
};

export default DeliverySlots;
